import React from 'react';
import { Spinner } from './Spinner';
import styles from './LoadingOverlay.module.css';

interface LoadingOverlayProps {
  message?: string;
  isFullScreen?: boolean;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ 
  message = 'Loading...', 
  isFullScreen = false 
}) => {
  return (
    <div 
      className={`${styles.overlay} ${isFullScreen ? styles.fullScreen : ''}`}
      role="alert"
      aria-busy="true"
      aria-live="polite"
    >
      <div className={styles.content}>
        <Spinner size="large" color="white" />
        {message && <p className={styles.message}>{message}</p>}
      </div>
    </div>
  );
};
